/* eslint-disable react/prop-types -- this codebase does not use propTypes (see CLAUDE.md). */
import { useLanguage } from "../../contexts/LanguageContext";
import { Modal, ErrorMessages } from "../../components/ui/Modal";
import { buttonClass } from "../../components/ui/styles";
import { displayName } from "./format";

// The only solid red button on the Team page lives here.
export default function RemoveMemberDialog({
  member,
  storeName,
  onClose,
  onConfirm,
  isPending,
  errors,
}) {
  const { t } = useLanguage();
  const name = displayName(member);

  return (
    <Modal
      open={!!member}
      onClose={() => !isPending && onClose()}
      role="alertdialog"
      title={t("team.remove.title", { name, store: storeName || "" })}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            disabled={isPending}
            className={buttonClass.secondary}
            data-autofocus
          >
            {t("common.cancel")}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isPending}
            className={buttonClass.danger}
          >
            {t("team.remove.confirm", { name })}
          </button>
        </>
      }
    >
      <ul className="m-0 flex list-disc flex-col gap-1.5 pl-[18px] text-sm leading-relaxed text-gray-700">
        <li>{t("team.remove.access", { name })}</li>
        <li>{t("team.remove.history", { name })}</li>
        <li>{t("team.remove.again")}</li>
      </ul>
      <ErrorMessages messages={errors} />
    </Modal>
  );
}
